import React from "react";
import mobile_push_icon_selected_white from "assets/notificationicons/mobile-push-icon-selected-white.png";
import mobile_push_icon_deselected_white from "assets/notificationicons/mobile-push-icon-deselected-white.png";
import email_icon_selected_white from "assets/notificationicons/email-icon-selected-white.png";
import email_icon_deselected_white from "assets/notificationicons/email-icon-deselected-white.png";

export default function NotificationActions({
  device,
  selectedDevices = [],
  toggleDevice,
  auth,
  setLoginPopupOpen,
  showLabels = false,
  size = "default", // "small", "default", "large"
}) {
  const selected = selectedDevices.find(
    (d) =>
      d.id === device.id &&
      d.node_id === device.node_id &&
      d.alias === device.alias &&
      d.workplace_id === device.workplace_id
  );

  const sizes = {
    small: {
      email: { width: 25, height: 18 },
      push: { width: 18, height: 22 },
    },
    default: {
      email: { width: 35, height: 25 },
      push: { width: 25, height: 30 },
    },
    large: {
      email: { width: 45, height: 32 },
      push: { width: 32, height: 38 },
    },
  };

  const handleClick = (type, e) => {
    e?.stopPropagation();
    // Always allow toggling - no auth check here
    // The save button will handle login prompt
    toggleDevice?.(device, type);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        gap: 15,
        alignContent: "center",
        alignItems: "center",
      }}
    >
      <div
        onClick={(e) => handleClick("email", e)}
        style={{ cursor: "pointer" }}
      >
        {(selected ? selected.emailEnabled === 0 : true) ? (
          <img
            src={email_icon_deselected_white}
            style={sizes[size].email}
            alt={showLabels ? "Email notification disabled" : ""}
          />
        ) : (
          <img
            src={email_icon_selected_white}
            style={sizes[size].email}
            alt={showLabels ? "Email notification enabled" : ""}
          />
        )}
      </div>
      <div
        style={{ marginLeft: 5, cursor: "pointer" }}
        onClick={(e) => handleClick("push", e)}
      >
        {(selected ? selected.pushEnabled === 0 : true) ? (
          <img
            src={mobile_push_icon_deselected_white}
            style={sizes[size].push}
            alt={showLabels ? "Push notification disabled" : ""}
          />
        ) : (
          <img
            src={mobile_push_icon_selected_white}
            style={sizes[size].push}
            alt={showLabels ? "Push notification enabled" : ""}
          />
        )}
      </div>
    </div>
  );
}
